export default "__VITE_ASSET__c2445eca__"